import { Text } from "@repo/components/src/ui/text";

type Props = {
  message: string;
};

/** Shown instead of the form for a country Montu doesn't operate in. */
export default function UnsupportedState({ message }: Props) {
  return (
    <Text size="sm" className="text-typography-600 leading-[19px]">
      {message}
    </Text>
  );
}
